<div class="modal-header">
    <h4 class="modal-title">
        <i data-feather="plus"></i> Yeni Model Ekle
    </h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="brandModelForm">
        <div class="col-12">
            <div class="form-group">
                <label for="brandId">Marka Seç</label>
                <input type="text" class="form-control" formControlName="brandName" id="basicInput"
                    placeholder="Marka adını giriniz." />

                <span *ngIf="brandModelForm.get('brandName')?.invalid && brandModelForm.get('brandName')?.touched"
                    class="text-danger">
                    Marka Zorunludur
                </span>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" [disabled]="brandModelForm.invalid"
        (click)="onSumbit()">Kaydet</button>
    <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
</div>